// Author Lin
// Date 2021-05-07 15:48:59

class SithMesMstBasicOperation {
        constructor({
                id = null,
                machineTypeId = '',
                basicHeaderId = '',
                operAct = '',
                workCenter = '',
                workCenterId = '',
                workCenterDescription = '',
                oprShortText = '',
                stdValue = '',
                stdUnit = '',
                activityId = '',
                pcStandard = '',
                operationQuantity = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.machineTypeId = machineTypeId;
            this.basicHeaderId = basicHeaderId;
            this.operAct = operAct;
            this.workCenter = workCenter;
            this.workCenterId = workCenterId;
            this.workCenterDescription = workCenterDescription;
            this.oprShortText = oprShortText;
            this.stdValue = stdValue;
            this.stdUnit = stdUnit;
            this.activityId = activityId;
            this.pcStandard = pcStandard;
            this.operationQuantity = operationQuantity;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new SithMesMstBasicOperation();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'machineTypeId',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.machineTypeId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'machineName',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.machineName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'basicHeaderId',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.basicHeaderId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'material',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.material',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'en',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.en',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cn',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.cn',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'operAct',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.operAct',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'workCenter',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.workCenter',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'workCenterId',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.workCenterId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'workCenterDescription',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.workCenterDescription',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'oprShortText',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.oprShortText',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'stdValue',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.stdValue',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'stdUnit',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.stdUnit',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'wbsCode',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.wbsCode',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'activityId',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.activityId',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pcStandard',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.pcStandard',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'operationQuantity',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.operationQuantity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.sith.mst.sithMesMstBasicOperation.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : "",
            idListFilter : "",
            machineTypeIdFilter : "",
            basicHeaderIdFilter : "",
            materialFilter : "",
            cnFilter : "",
            operActFilter : "",
            workCenterFilter : "",
            workCenterIdFilter : "",
            workCenterDescriptionFilter : "",
            oprShortTextFilter : "",
            stdValueFilter : "",
            stdUnitFilter : "",
            wbsCodeFilter : "",
            activityIdFilter : "",
            pcStandardFilter : "",
            operationQuantityFilter : ""
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'machineTypeIdFilter',
                label: 'label.sith.mst.sithMesMstBasicOperation.filter.machineTypeId',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'sithMesMstMachineType'
                    ,correspondingField: 'id'
                        }
                },
                {
                key: 'basicHeaderIdFilter',
                label: 'label.sith.mst.sithMesMstBasicOperation.filter.basicHeaderId',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'sithMesMstBasicHeader'
                    ,correspondingField: 'id'
                        }
                },
                {
                key: 'materialFilter',
                label: 'label.sith.mst.sithMesMstBasicOperation.filter.material',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'cnFilter',
                label: 'label.sith.mst.sithMesMstBasicOperation.filter.cn',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'operActFilter',
                label: 'label.sith.mst.sithMesMstBasicOperation.filter.operAct',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'workCenterFilter',
                label: 'label.sith.mst.sithMesMstBasicOperation.filter.workCenter',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'sithMesMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"workCenterId":"id"}'
                        }
                },
                {
                key: 'workCenterDescriptionFilter',
                label: 'label.sith.mst.sithMesMstBasicOperation.filter.workCenterDescription',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'oprShortTextFilter',
                label: 'label.sith.mst.sithMesMstBasicOperation.filter.oprShortText',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'stdValueFilter',
                label: 'label.sith.mst.sithMesMstBasicOperation.filter.stdValue',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'stdUnitFilter',
                label: 'label.sith.mst.sithMesMstBasicOperation.filter.stdUnit',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'wbsCodeFilter',
                label: 'label.sith.mst.sithMesMstBasicOperation.filter.wbsCode',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'activityIdFilter',
                label: 'label.sith.mst.sithMesMstBasicOperation.filter.activityId',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'pcStandardFilter',
                label: 'label.sith.mst.sithMesMstBasicOperation.filter.pcStandard',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'operationQuantityFilter',
                label: 'label.sith.mst.sithMesMstBasicOperation.filter.operationQuantity',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                }
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'machineTypeId',
                label: 'label.sith.mst.sithMesMstBasicOperation.entity.machineTypeId',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'sithMesMstMachineType'
                    ,correspondingField: 'id'
                        }
                },
                {
                key: 'basicHeaderId',
                label: 'label.sith.mst.sithMesMstBasicOperation.entity.basicHeaderId',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'sithMesMstBasicHeader'
                    ,correspondingField: 'id'
                        }
                },
                {
                key: 'operAct',
                label: 'label.sith.mst.sithMesMstBasicOperation.entity.operAct',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'workCenter',
                label: 'label.sith.mst.sithMesMstBasicOperation.entity.workCenter',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'sithMesMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"workCenterId":"id"}'
                        }
                },
                {
                key: 'workCenterDescription',
                label: 'label.sith.mst.sithMesMstBasicOperation.entity.workCenterDescription',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'oprShortText',
                label: 'label.sith.mst.sithMesMstBasicOperation.entity.oprShortText',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'stdValue',
                label: 'label.sith.mst.sithMesMstBasicOperation.entity.stdValue',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'stdUnit',
                label: 'label.sith.mst.sithMesMstBasicOperation.entity.stdUnit',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'activityId',
                label: 'label.sith.mst.sithMesMstBasicOperation.entity.activityId',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'pcStandard',
                label: 'label.sith.mst.sithMesMstBasicOperation.entity.pcStandard',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'operationQuantity',
                label: 'label.sith.mst.sithMesMstBasicOperation.entity.operationQuantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'remark',
                label: 'label.sith.mst.sithMesMstBasicOperation.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {SithMesMstBasicOperation, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        